import { useQuery } from '@tanstack/react-query';
import { Rocket, Cpu, Shield, MessagesSquare } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { api } from '@/lib/api-client';
import { formatNumber } from '@/lib/utils';
import type { DashboardOverview } from '@/lib/types';

interface Card {
  label: string;
  value: string;
  icon: LucideIcon;
}

export function Dashboard(): JSX.Element {
  const overview = useQuery({
    queryKey: ['/api/admin/overview'],
    queryFn: () => api.get<DashboardOverview>('/api/admin/overview'),
  });

  const d = overview.data;
  const cards: Card[] = [
    { label: 'Deployments', value: formatNumber(d?.deploymentCount ?? 0), icon: Rocket },
    { label: 'Models', value: formatNumber(d?.modelCount ?? 0), icon: Cpu },
    { label: 'Swap Profiles', value: formatNumber(d?.swapProfileCount ?? 0), icon: Shield },
    {
      label: 'Recent Conversations',
      value: formatNumber(d?.recentConversationCount ?? 0),
      icon: MessagesSquare,
    },
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-heading">Dashboard</h2>

      {overview.isError && (
        <p className="text-sm text-rose-600">
          Az áttekintés betöltése nem sikerült: {String(overview.error)}
        </p>
      )}

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.label} className="card p-4">
              <div className="flex items-center justify-between">
                <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                  {c.label}
                </p>
                <Icon className="h-4 w-4 text-echo-gold" />
              </div>
              <p className="mt-2 text-2xl font-bold text-heading">{c.value}</p>
            </div>
          );
        })}
      </div>

      <div className="card p-6">
        <h3 className="text-base font-semibold text-heading">EchoProxy gateway</h3>
        <p className="mt-2 text-sm text-muted-foreground">
          PII-cserélő LLM-gateway. A deployment-ek a swap profil szerint placeholderre
          cserélik a kimenő forgalom érzékeny adatait, majd a modell válaszában
          visszaállítják az eredeti értékeket. Kezeld a deployment-eket, modelleket
          és swap profilokat a bal oldali menüből.
        </p>
      </div>
    </div>
  );
}
